/**
 * Ground-truth tagging for `email_inbox_log` (half-claw calibration).
 * @see docs/APP_UI_SPEC.md — D2
 * @see docs/PLAN_HALF_CLAW_GOLD_DATASET.md
 */

/** Canonical intents aligned with `email-classify.ts` LLM schema. */
export const INBOX_GROUND_TRUTH_INTENTS = [
  'confirm',
  'decline',
  'date_change_request',
  'slot_preference',
  'info_request',
  'ambiguous',
  'unrelated',
];

/**
 * Persist operator-tagged ground truth on an inbox row.
 *
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {string} rowId - `email_inbox_log.id`
 * @param {{ intent: string|null, application_ids?: number[]|null, notes?: string|null, set_by: string }} fields
 * @returns {Promise<{ error: Error|null }>}
 */
export async function setInboxRowGroundTruth(supabase, rowId, fields) {
  const now = new Date().toISOString();
  const payload = {
    ground_truth_intent: fields.intent,
    ground_truth_set_at: now,
    ground_truth_set_by: fields.set_by,
  };
  if (fields.application_ids !== undefined) {
    payload.ground_truth_application_ids = fields.application_ids;
  }
  if (fields.notes !== undefined) {
    payload.ground_truth_notes = fields.notes;
  }
  const { error } = await supabase.from('email_inbox_log').update(payload).eq('id', rowId);
  return { error: error || null };
}

/**
 * Set implicit ground truth from Confirm/Reject only when the row is still untagged.
 *
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {string} rowId
 * @param {{ intent: 'confirm'|'decline', application_ids: number[], set_by: string }} fields
 */
export async function setInboxRowGroundTruthIfUnset(supabase, rowId, fields) {
  const now = new Date().toISOString();
  const { error } = await supabase
    .from('email_inbox_log')
    .update({
      ground_truth_intent: fields.intent,
      ground_truth_application_ids: fields.application_ids,
      ground_truth_set_at: now,
      ground_truth_set_by: fields.set_by,
    })
    .eq('id', rowId)
    .is('ground_truth_intent', null);
  return { error: error || null };
}
